import React from 'react';
import { Switch, Route } from 'react-router-dom';
import VersementList from './versement-list';
import VersementForms from './versement-forms';
import { paths } from '../../../routes';

const Versement = () => (
  <Switch>
    <Route path={paths.versement.path} exact>
      <VersementList />
    </Route>
    <Route path={paths.newVersement.path}>
      <VersementForms />
    </Route>
    <Route path={paths.versement.path + '/:reportId'}>
      <VersementForms />
    </Route>
  </Switch>
);

export default Versement;
